module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"book-create":"Создать новый объект","book-info":"Редактировать объект","book-edit":"Редактировать группу объектов"}}')
  delete Component.options._Ctor
}
